import React from 'react'

import Stepper from '../../../../../../common/inputs/stepper/Stepper'
import { FieldProps } from '../../../../../../../@types/types'
import { WhoWeLookForScreenValidationResult } from '../../../../../../../@types/validation-types'

const NumberOfFemaleFlatMates: React.FC<FieldProps<WhoWeLookForScreenValidationResult>> = ({
  validationMessages,
  insertionData,
  screenName,
  onChange,
}) => (
  <div className='margin-top-m palm-one-whole lap-one-half desk-one-half lap-padding-left-m desk-padding-left-m'>
    <Stepper
      id='number-of-female-flat-mates'
      propertyName='numberOfFemaleFlatMates'
      placeholder=''
      label='wizard.screen.whoWeLookFor.numberOfFemaleFlatMates'
      input={insertionData.numberOfFemaleFlatMates}
      type='tel'
      maxLength={4}
      max={999}
      errors={validationMessages!.numberOfFemaleFlatMates ?? []}
      doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, value)}
    />
  </div>
)

export default NumberOfFemaleFlatMates
